import styled from 'styled-components';
import { buttons as socialData } from './Socials/dataset';
import * as IconsOutline from './Socials/icons/outline';
import * as IconsSolid from './Socials/icons/solid';
import * as SocialButtons from './Socials/index';
import Social from './Socials/Social';

export default function Socials({ pageId, buttons, iconStyle, socialsBorder, onClick }) {
	const renderSocial = buttons.map((b, i) => {
		if ((!b.value || !b.value.length) && !b.valueIsSet) {
			return null;
		}

		if (!socialData[b.type]) {
			return null;
		}

		let Svg = IconsOutline[b.type] ? IconsOutline[b.type] : null;
		if ('solid' === iconStyle) {
			Svg = IconsSolid[b.type] ? IconsSolid[b.type] : null;
		}

		if (SocialButtons[b.type]) {
			const TagName = SocialButtons[b.type];
			return (
				<TagName onClick={onClick} pageId={pageId} socialData={socialData[b.type]} key={i} {...b}>
					<Svg />
				</TagName>
			);
		}

		return (
			<Social onClick={onClick} pageId={pageId} socialData={socialData[b.type]} key={i} {...b}>
				<Svg />
			</Social>
		);
	});

	return (
		<div className="container" id="slp-Socials">
			<StyledSocials socialsBorder={socialsBorder}>{renderSocial}</StyledSocials>
		</div>
	);
}

const StyledSocials = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	gap: 1%;

	.btn {
		${(props) => ('hide' === props.socialsBorder ? 'border: none;' : '')}
		flex: 1;
		margin-bottom: 0.618rem;
		padding: 0.75rem 0;
		flex-basis: ${(props) => ('hide' === props.socialsBorder ? '15.618%' : '24%')};
		flex-grow: 0;
		flex-shrink: 0;
	}
`;
